import { GenerateDeliveryNoteActionContext } from "./GenerateDeliveryNoteActionContext";
import useGenerateDeliveryNote from "./useGenerateDeliveryNote";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import usePrepareGenerateDeliveryNote from "./usePrepareGenerateDeliveryNote";
import { Form } from "react-bootstrap";

function useGenerateDeliveryNoteAction(modelConfig: any, index: any): any {
  const prepareGenerateDeliveryNote = usePrepareGenerateDeliveryNote();
  const prepareGenerateDeliveryNoteFunction = (id: any) => prepareGenerateDeliveryNote(id);

  const onSuccessGenerateDeliveryNote = () => {
    setShowModal(false);
    index();
  };

  const pay = useGenerateDeliveryNote(modelConfig);

  const payFunction = () => pay(onSuccessGenerateDeliveryNote);

  const contextInstance = useContext(GenerateDeliveryNoteActionContext);
  const { setShowModal, generatePdf, setGeneratePdf, sendToCustomer, setSendToCustomer, separatedInvoices, setSeparatedInvoices } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "generate-delivery-note",
    onSubmit: () => payFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <div>
        <p>{t(`are_you_sure_you_want_to_generate_the_delivery_note_for_these_${modelConfig.modelName}?`)}</p>
        <Form.Group className="mt-3">
          <Form.Check 
            type="checkbox"
            id="separated-invoices-checkbox-delivery-note"
            label={t("separated_invoices")}
            checked={separatedInvoices}
            onChange={(e) => setSeparatedInvoices(e.target.checked)}
          />
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Check 
            type="checkbox"
            id="generate-pdf-checkbox-delivery-note"
            label={t("generate_pdf")}
            checked={generatePdf}
            onChange={(e) => {
              setGeneratePdf(e.target.checked);
              // Si se desmarca generatePdf, desmarcar sendToCustomer también
              if (!e.target.checked) {
                setSendToCustomer(false);
              }
            }}
          />
        </Form.Group>
        <Form.Group className="mt-2">
          <Form.Check 
            type="checkbox"
            id="send-to-customer-checkbox-delivery-note-action"
            label={t("send_to_customer")}
            checked={sendToCustomer}
            disabled={!generatePdf}
            onChange={(e) => setSendToCustomer(e.target.checked)}
          />
          {!generatePdf && (
            <Form.Text className="text-muted">
              {t("requires_generate_pdf")}
            </Form.Text>
          )}
        </Form.Group>
      </div>
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareGenerateDeliveryNoteFunction,
    actionTemplate,
  };
}

export default useGenerateDeliveryNoteAction;
